// extracted by mini-css-extract-plugin
module.exports = {"container":"MaterialInputArea_container__1WScN","label":"MaterialInputArea_label__1x0zE","collapse":"MaterialInputArea_collapse__3AO_I","input":"MaterialInputArea_input__ZQ6yz"};